import { Platform } from "react-native"

/** Android WebView can't render remote PDFs natively — proxy via Google Docs viewer (legacy parity). */
export function resolveNativeWebViewUrl(url: string): string {
    if (
        Platform.OS === "android" &&
        url.startsWith("https") &&
        (url.toLowerCase().endsWith(".pdf") || url.toLowerCase().includes(".pdf?"))
    ) {
        return `https://docs.google.com/gview?embedded=true&url=${encodeURIComponent(url)}`
    }
    return url
}

export function isYoutubeUrl(url: string): boolean {
    const lower = url.toLowerCase()
    return lower.includes("youtube.com") || lower.includes("youtu.be")
}

/** Normalize common YouTube URL shapes to a watch URL `react-player` can play. */
export function sanitizeYoutubeUrl(url: string): string | null {
    if (!url || typeof url !== "string") return null
    const cleanUrl = url.trim()
    const patterns = [
        /(?:https?:\/\/)?(?:www\.)?youtube\.com\/watch\?v=([a-zA-Z0-9_-]{11})/,
        /(?:https?:\/\/)?youtu\.be\/([a-zA-Z0-9_-]{11})/,
        /(?:https?:\/\/)?(?:www\.)?youtube\.com\/embed\/([a-zA-Z0-9_-]{11})/,
        /(?:https?:\/\/)?(?:www\.)?youtube\.com\/watch\?.*v=([a-zA-Z0-9_-]{11})/,
    ]
    for (const pattern of patterns) {
        const match = cleanUrl.match(pattern)
        if (match?.[1]) return `https://www.youtube.com/watch?v=${match[1]}`
    }
    return isYoutubeUrl(cleanUrl) ? cleanUrl : null
}
